var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"p2p-market-your-request-list"}},[_c('h1',[_vm._v(_vm._s(_vm.$t("BUY_REQUEST")))]),_c('your-buy-sell-table',{attrs:{"type":"BUY"}}),_c('el-divider'),_c('h1',[_vm._v(_vm._s(_vm.$t("SELL_REQUEST")))]),_c('your-buy-sell-table',{attrs:{"type":"SELL"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }